import { Button, Card, DatePicker, Input, InputNumber, Table } from "antd";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addPayslip,
  clearPayroll,
  loadAllPayslip,
  updatePayslip,
} from "../../redux/rtk/features/payroll/payrollSlice";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";


function CustomTable({ list, loading, dynamicAdditions, setDynamicAdditions, dynamicDeductions, setDynamicDeductions }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const dispatch = useDispatch();

  // const salaryComponents = useSelector((state) => state.salaryComponents?.list);

  const handleAddAddition = useCallback((record) => {
    console.log("addDynamic called", record)
    const newAdditions = {
      ...dynamicAdditions,
      [record.id]: [
        ...(dynamicAdditions[record.id] || []),
        {
          id: Date.now().toString(),
          name: '',
          value: 0,
          comment: ''
        }
      ]
    };
    setDynamicAdditions({ ...newAdditions });

    // Update the total payable
    // const totalAdditions = newAdditions[record.id]?.reduce((sum, item) => sum + (Number(item.value) || 0), 0) || 0;
    // dispatch(updatePayslip({
    //   id: record.id,
    //   value: totalAdditions,
    //   key: "totalDynamicAdditions"
    // }));

  }, [dynamicAdditions, setDynamicAdditions]);

  const handleAddDeduction = (record) => {
    const newDeductions = {
      ...dynamicDeductions,
      [record.id]: [
        ...((dynamicDeductions[record.id] || [])),
        {
          id: Date.now().toString,
          name: '',
          value: 0,
          comment: ''
        }
      ]
    };
    setDynamicDeductions({ ...newDeductions });

    // Update the total payable
    // const totalDeductions = newDeductions[record.id]?.reduce((sum, item) => sum + (Number(item.value) || 0), 0) || 0;
    // dispatch(updatePayslip({
    //   id: record.id,
    //   value: totalDeductions,
    //   key: "totalDynamicDeductions"
    // }));
  };

  const handleRemoveField = (recordId, fieldId, type) => {
    if (type === 'addition') {
      const newAdditions = {
        ...dynamicAdditions,
        // [recordId]: dynamicAdditions[recordId].filter(item => item.id !== fieldId)
        [recordId]: (dynamicAdditions[recordId] || []).filter(item => item.id !== fieldId)
      };
      setDynamicAdditions({ ...newAdditions });
    } else {
      const newDeductions = {
        ...dynamicDeductions,
        // [recordId]: dynamicDeductions[recordId].filter(item => item.id !== fieldId)
        [recordId]: (dynamicDeductions[recordId] || []).filter(item => item.id !== fieldId)
      };
      setDynamicDeductions({ ...newDeductions });
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      title: "Name",
      key: "name",
      render: (record) => `${record.firstName} ${record.lastName}`,
    },

    {
      title: "Basic Salary",
      dataIndex: "salary",
      key: "salary",
    },

    {
      title: "Basic Payable",
      dataIndex: "salaryPayable",
      key: "salaryPayable",
      render: (salaryPayable, { id }) => {
        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "110px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "salaryPayable" }));
              }}
              value={salaryPayable}
              min={0}
            // defaultValue={salaryPayable}
            />{" "}
          </div>
        );
      },
    },

    {
      title: "Overtime Payable",
      dataIndex: "overtimePayable",
      key: "overtimePayable",
      render: (overtimePayable, { id }) => {

        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "110px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "overtimePayable" }));
              }}
              value={overtimePayable}
              min={0}
            // defaultValue={salaryPayable}
            />{" "}
          </div>
        );
      },
    },

    {
      title: "Accommodation",
      dataIndex: "accommodation",
      key: "accommodation",
      render: (accommodation, { id }) => {
        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "100px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "accommodation" }));
              }}
              value={accommodation}
              min={0}
            />{" "}
          </div>
        );
      },
    },

    // {
    //   title: "Bonus",
    //   dataIndex: "bonus",
    //   key: "bonus",
    //   render: (bonus, { id }) => {
    //     return (
    //       <div>
    //         <InputNumber
    //           size={"small"}
    //           style={{ width: "100px", fontSize: "15px" }}
    //           onChange={(value) => {
    //             dispatch(updatePayslip({ id, value, key: "bonus" }));
    //           }}
    //           value={bonus}
    //           min={0}
    //         // defaultValue={bonus}
    //         />{" "}
    //       </div>
    //     );
    //   },
    // },

    // {
    //   title: "B-Comment",
    //   dataIndex: "bonusComment",
    //   key: "bonusComment",
    //   render: (bonusComment, { id }) => {
    //     return (
    //       <div>
    //         <Input
    //           placeholder="comment"
    //           size={"small"}
    //           style={{ width: "100px", fontSize: "15px" }}
    //           onChange={(e) => {
    //             dispatch(
    //               updatePayslip({
    //                 id,
    //                 value: e.target.value,
    //                 key: "bonusComment",
    //               })
    //             );
    //           }}
    //           value={bonusComment}

    //         // defaultValue={deductionComment}
    //         />{" "}
    //       </div>
    //     );
    //   },
    // },

    {
      title: "Loan Payment",
      dataIndex: "emi",
      key: "emi",
      render: (emi, { id }) => {
        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "100px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "emi" }));
              }}
              value={emi}
              min={0}
            />
          </div>
        );
      },
    },

    {
      title: "Tax",
      dataIndex: "tax",
      key: "tax",
      render: (tax, { id }) => {
        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "100px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "tax" }));
              }}
              value={tax}
              min={0}
            />
          </div>
        );
      },
    },

    {
      title: "Employer NI",
      dataIndex: "EmployerNi",
      key: "employerNi",
      render: (employerNi, { id }) => {
        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "100px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "employerNi" }));
              }}
              value={employerNi}
              min={0}
            />
          </div>
        );
      },
    },

    {
      title: "Employee NI",
      dataIndex: "ni",
      key: "ni",
      render: (ni, { id }) => {
        return (
          <div>
            <InputNumber
              size={"small"}
              style={{ width: "100px", fontSize: "15px" }}
              onChange={(value) => {
                dispatch(updatePayslip({ id, value, key: "ni" }));
              }}
              value={ni}
              min={0}
            />
          </div>
        );
      },
    },

    // {
    //   title: "Deduction",
    //   dataIndex: "deduction",
    //   key: "deduction",
    //   render: (deduction, { id }) => {
    //     return (
    //       <div>
    //         <InputNumber
    //           size={"small"}
    //           style={{ width: "100px", fontSize: "15px" }}
    //           onChange={(value) => {
    //             dispatch(updatePayslip({ id, value, key: "deduction" }));
    //           }}
    //           value={deduction}
    //           min={0}
    //         // defaultValue={deduction}
    //         />{" "}
    //       </div>
    //     );
    //   },
    // },

    // {
    //   title: "D-Comment",
    //   dataIndex: "deductionComment",
    //   key: "deductionComment",
    //   render: (deductionComment, { id }) => {
    //     return (
    //       <div>
    //         <Input
    //           placeholder="comment"
    //           size={"small"}
    //           style={{ width: "100px", fontSize: "15px" }}
    //           onChange={(e) => {
    //             dispatch(
    //               updatePayslip({
    //                 id,
    //                 value: e.target.value,
    //                 key: "deductionComment",
    //               })
    //             );
    //           }}
    //           value={deductionComment}

    //         // defaultValue={deductionComment}
    //         />{" "}
    //       </div>
    //     );
    //   },
    // },

    // {
    //   title: "Working Hours",
    //   dataIndex: "workingHour",
    //   key: "workingHour",
    //   render: (workingHour) => `${workingHour?.toFixed(2)} hours`,
    // },

    {
      title: "Total Payable",
      dataIndex: "totalPayable",
      key: "totalPayable",
    },

    // {
    //   title: "Dynamic Additions",
    //   key: "dynamicAdditions",
    //   render: (record) => (
    //     <div className="flex flex-col">
    //       {(dynamicAdditions[record.id] || []).map((field) => (
    //         <div key={field.id} className="flex items-center mb-2">
    //           <Input
    //             placeholder="Name"
    //             size="small"
    //             style={{ width: "100px", marginRight: "4px" }}
    //             value={field.name}
    //             onChange={(e) => {
    //               const newAdditions = {
    //                 ...dynamicAdditions,
    //                 [record.id]: (dynamicAdditions[record.id] || []).map(item =>
    //                   item.id === field.id ? { ...item, name: e.target.value } : item
    //                 )
    //               };
    //               setDynamicAdditions({...newAdditions});
    //             }}
    //           />
    //           <InputNumber
    //             size="small"
    //             style={{ width: "100px", marginRight: "4px" }}
    //             value={field.value}
    //             onChange={(value) => {
    //               const newAdditions = {
    //                 ...dynamicAdditions,
    //                 [record.id]: (dynamicAdditions[record.id] || []).map(item =>
    //                   item.id === field.id ? { ...item, value } : item
    //                 )
    //               };
    //               setDynamicAdditions({ ...newAdditions });
    //             }}
    //           />
    //           <Input
    //             placeholder="Comment"
    //             size="small"
    //             style={{ width: "100px", marginRight: "4px" }}
    //             value={field.comment}
    //             onChange={(e) => {
    //               const newAdditions = {
    //                 ...dynamicAdditions,
    //                 [record.id]: (dynamicAdditions[record.id] || []).map(item =>
    //                   item.id === field.id ? { ...item, comment: e.target.value } : item
    //                 )
    //               };
    //               setDynamicAdditions({ ...newAdditions });
    //             }}
    //           />
    //           <DeleteOutlined
    //             onClick={() => handleRemoveField(record.id, field.id, 'addition')}
    //             style={{ color: 'red', cursor: 'pointer' }}
    //           />
    //         </div>
    //       ))}
    //       <Button
    //         type="dashed"
    //         onClick={() => handleAddAddition(record)}
    //         icon={<PlusOutlined />}
    //         size="small"
    //       >
    //         Add Field
    //       </Button>
    //     </div>
    //   )
    // },
    // {
    //   title: "Dynamic Deductions",
    //   key: "dynamicDeductions",
    //   render: (record) => (
    //     <div className="flex flex-col">
    //       {dynamicDeductions[record.id]?.map((field) => (
    //         <div key={field.id} className="flex items-center mb-2">
    //           <Input
    //             placeholder="Name"
    //             size="small"
    //             style={{ width: "100px", marginRight: "4px" }}
    //             value={field.name}
    //             onChange={(e) => {
    //               const newDeductions = {
    //                 ...dynamicDeductions,
    //                 [record.id]: dynamicDeductions[record.id].map(item =>
    //                   item.id === field.id ? { ...item, name: e.target.value } : item
    //                 )
    //               };
    //               setDynamicDeductions({ ...newDeductions });
    //             }}
    //           />
    //           <InputNumber
    //             size="small"
    //             style={{ width: "100px", marginRight: "4px" }}
    //             value={field.value}
    //             onChange={(value) => {
    //               const newDeductions = {
    //                 ...dynamicDeductions,
    //                 [record.id]: (dynamicDeductions[record.id] || []).map(item =>
    //                   item.id === field.id ? { ...item, value } : item
    //                 )
    //               };
    //               setDynamicDeductions({ ...newDeductions });
    //             }}
    //           />
    //           <Input
    //             placeholder="Comment"
    //             size="small"
    //             style={{ width: "100px", marginRight: "4px" }}
    //             value={field.comment}
    //             onChange={(e) => {
    //               const newDeductions = {
    //                 ...dynamicDeductions,
    //                 [record.id]: (dynamicDeductions[record.id] || []).map(item =>
    //                   item.id === field.id ? { ...item, comment: e.target.value } : item
    //                 )
    //               };
    //               setDynamicDeductions({ ...newDeductions });
    //             }}
    //           />
    //           <DeleteOutlined
    //             onClick={() => handleRemoveField(record.id, field.id, 'deduction')}
    //             style={{ color: 'red', cursor: 'pointer' }}
    //           />
    //         </div>
    //       ))}
    //       <Button
    //         type="dashed"
    //         onClick={() => handleAddDeduction(record)}
    //         icon={<PlusOutlined />}
    //         size="small"
    //       >
    //         Add Field
    //       </Button>
    //     </div>
    //   )
    // }
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


  const exportData = list.map((item, index) => ({
    serial: index + 1,
    firstName: item.firstName,
    lastName: item.lastName,
    employeeId: item.employeeId,
    salaryMonth: item.salaryMonth,
    salaryYear: item.salaryYear,
    salary: item.salary,
    presentDays: item.presentDays,
    // bonus: item.bonus,
    // bonusComment: item.bonusComment,
    // deduction: item.deduction,
    tax: item.tax,
    employerNi: item.employerNi,
    ni: item.ni,
    // deductionComment: item.deductionComment,
    overtimePayable: item.overtimePayable,
    overtimeHours: item.overtimeHours,
    emi: item.emi,
    totalPayable: item.totalPayable,
    totalLeavesTaken: item.totalLeavesTaken,
  }));

  const headers = [
    { label: "S.No", key: "serial" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Employee ID", key: "employeeId" },
    { label: "Salary Month", key: "salaryMonth" },
    { label: "Salary Year", key: "salaryYear" },
    { label: "Basic Salary", key: "salary" },
    { label: "Present Days", key: "presentDays" },
    { label: "Overtime Hours", key: "overtimeHours" },
    { label: "Overtime Payable", key: "overtimePayable" },
    // { label: "Bonus", key: "bonus" },
    // { label: "Bonus Comment", key: "bonusComment" },
    // { label: "Deduction", key: "deduction" },
    // { label: "Deduction Comment", key: "deductionComment" },
    { label: "Tax", key: "tax" },
    { label: "Loan Payment", key: "emi" },
    { label: "Employer Ni", key: "employerNi" },
    { label: "Employee NI", key: "ni" },
    { label: "Total Payable", key: "totalPayable" },
    { label: "Total Leaves Taken", key: "totalLeavesTaken" },
  ];



  return (
    <div className="mt-5">
      <div className="text-center my-2 flex justify-between">
        {list && (
          <div style={{ marginBottom: "30px" }}>
            <ColVisibilityDropdown
              options={columns}
              columns={columns}
              columnsToShowHandler={columnsToShowHandler}
            />
          </div>
        )}

        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={exportData} headers={headers} filename="Salary_Report.csv"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}

      </div>

      <Table
        scroll={{ x: true }}
        loading={loading}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
        expandable={{
          expandedRowRender: (record) => (
            <div className="flex justify-start">
              <div className="flex flex-col mr-10">
                <div className="flex justify-between">
                  <div className="font-bold">Paid Leave : </div>
                  <div>{record.paidLeave}</div>
                </div>
                <div className="flex justify-between">
                  <div className="font-bold">Unpaid Leave : </div>
                  <div className="ml-2">{record.unpaidLeave}</div>
                </div>
              </div>

              <div className="flex flex-col mr-10">
                <div className="flex justify-between ">
                  <div className="font-bold">M-Holiday : </div>
                  <div>{record.monthlyHoliday}</div>
                </div>
                <div className="flex justify-between">
                  <div className="font-bold">P-Holiday : </div>
                  <div>{record.publicHoliday}</div>
                </div>
              </div>

              <div className="flex flex-col mr-10">
                <div className="flex justify-between">
                  <div className="font-bold">Work Day : </div>
                  <div className="ml-2">{record.workDay}</div>
                </div>
                <div className="flex justify-between">
                  <div className="font-bold"> Shift W.H : </div>
                  <div>{record.shiftWiseWorkHour}</div>
                </div>
              </div>

              <div className="flex flex-col mr-10">
                <div className="flex justify-between">
                  <div className="font-bold">Total Present : </div>
                  <div className="ml-2">{record.presentDays}</div>
                </div>
                {/* <div className="flex flex-col mr-10"> */}
                {/* <div className="flex justify-between">
                  <div className="font-bold">Absent : </div>
                  <div className="ml-2">{record.totalAbsents}</div>
                </div>
              </div>

              <div className="flex flex-col mr-10">
                <div className="flex justify-between">
                  <div className="font-bold">Half Day : </div>
                  <div className="ml-2">{record.totalHalfDays}</div>
                </div> */}
                {/* </div> */}
                <div className="flex justify-between">
                  <div className="font-bold">O.T. Hours : </div>
                  <div className="ml-2">{record.overtimeHours}</div>
                </div>
              </div>
              <div className="flex flex-col mr-10">
                <div className="flex justify-between">
                  <div className="font-bold">Annual Leave : </div>
                  <div className="ml-2">{record.totalLeavesTaken}</div>
                </div>
                {/* <div className="flex justify-between">
                  <div className="font-bold">Unpaid Leave : </div>
                  <div className="ml-2">{record.unpaidLeave}</div>
                </div> */}
              </div>

            </div>
          ),
          rowExpandable: (record) => record.name !== "Not Expandable",
        }}
      />
    </div>
  );
}

const CalculatePayroll = () => {
  const [month, setMonth] = useState(dayjs().format("M"));
  const [year, setYear] = useState(dayjs().format("YYYY"));
  const [loading, setLoading] = useState(false);

  const [dynamicAdditions, setDynamicAdditions] = useState({});
  const [dynamicDeductions, setDynamicDeductions] = useState({});
  const [updateTrigger, setUpdateTrigger] = useState(0);

  const payroll = useSelector((state) => state.payroll.list);
  const loader = useSelector((state) => state.payroll.loading);

  const dispatch = useDispatch();
  const [payslips, setPayslips] = useState([]);


  useEffect(() => {
    dispatch(loadAllPayslip({ month, year }));
    // dispatch(loadAllSalaryComponents())

    return () => {
      dispatch(clearPayroll());
    };
  }, [month, year, updateTrigger]);

  useEffect(() => {
    setPayslips(payroll);
    console.log("payslipStore", payslips)
  }, [payroll]);

  const handleDynamicAdditionsUpdate = (newAdditions) => {
    setDynamicAdditions(newAdditions);
    setUpdateTrigger(prev => prev + 1);
  };

  const handleDynamicDeductionsUpdate = (newDeductions) => {
    setDynamicDeductions(newDeductions);
    setUpdateTrigger(prev => prev + 1);
  };

  const onMonthChange = async (date, dateString) => {
    console.log("MonthDateString", dateString);

    // Map month names to their corresponding numbers
    const monthMapping = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    // Get the numeric month from the dateString
    const newMonth = monthMapping[dateString];
    console.log("newMonth", newMonth);

    // Set the month and dispatch the action
    setMonth(newMonth);

    dispatch(loadAllPayslip({ month: newMonth, year }));
  };


  const onYearChange = (date, dateString) => {
    console.log("YearDateString", dateString)
    setYear(dateString);
    dispatch(loadAllPayslip({ month, year: dateString }));
  };

  const navigate = useNavigate();

  const OnSubmit = async () => {
    // console.log("OnSubmit Clicked");
    setLoading(true);
    const dataArray = payslips.map((i) => ({
      userId: i.id,
      salaryMonth: parseInt(month),
      salaryYear: parseInt(year),
      salary: i.salary,
      paidLeave: i.paidLeave,
      unpaidLeave: i.unpaidLeave,
      monthlyHoliday: i.monthlyHoliday,
      publicHoliday: i.publicHoliday,
      workDay: i.workDay,
      shiftWiseWorkHour: i.shiftWiseWorkHour,
      monthlyWorkHour: i.monthlyWorkHour,
      hourlySalary: i.hourlySalary,
      totalFullDays: i.totalFullDays,
      totalHalfDays: i.totalHalfDays,
      totalAbsents: i.totalAbsents,
      salaryPerDay: i.salaryPerDay,
      // perDaySalary: i.perDaySalary,
      bonus: i.bonus,
      bonusComment: i.bonusComment,
      deduction: i.deduction,
      deductionComment: i.deductionComment,
      totalPayable: i.totalPayable,
      workingHour: i.workingHour,
      salaryPayable: i.salaryPayable,
      overtimePayable: i.overtimePayable,
      overtimeHours: i.overtimeHours,
      loans: i.loans,
      emi: i.emi,
      tax: i.tax,
      ni: i.ni
      // dynamicAdditions: dynamicAdditions[i.id] || [],
      // dynamicDeductions: dynamicDeductions[i.id] || [],
      // totalPayable: calculateTotalPayable(i)

      // salaryComponents: i.salaryComponents.map(component => ({
      //   salaryComponentId: component.salaryComponentId,
      //   value: component.value,
      //   componentPayable: component.componentPayable
      // }))
    }));

    console.log("dataArray", dataArray)
    // setLoading(false);


    try {
      const resp = await dispatch(addPayslip(dataArray));
      if (resp.payload.message === "success") {
        setLoading(false);
        navigate("/admin/payroll/list");
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // Helper function to calculate total payable
  const calculateTotalPayable = (record) => {
    const additions = dynamicAdditions[record.id]?.reduce((sum, item) => sum + (Number(item.value) || 0), 0) || 0;
    const deductions = dynamicDeductions[record.id]?.reduce((sum, item) => sum + (Number(item.value) || 0), 0) || 0;
    return record.salaryPayable + additions - deductions;
  };

  return (
    <div>
      <PageTitle title="Back" />
      <UserPrivateComponent permission={"readAll-payroll"}>
        <Card className="mt-5">
          <div className="flex justify-end">
            <h1 className="text-base text-color-2 items-center mr-2 mt-1">
              {" "}
              Select Month :{" "}
            </h1>
            <DatePicker
              format={"MMM"}
              className=" mr-5"
              style={{ maxWidth: "200px" }}
              picker="month"
              defaultValue={dayjs()}
              onChange={onMonthChange}
            />
            <h1 className="text-base text-color-2 items-center mr-2 mt-1">
              {" "}
              Select Year :{" "}
            </h1>
            <DatePicker
              format={"YYYY"}
              picker="year"
              style={{ maxWidth: "200px" }}
              onChange={onYearChange}
              defaultValue={dayjs()}
            />
          </div>

          <CustomTable
            list={payroll}
            loading={loader}
            dynamicAdditions={dynamicAdditions}
            setDynamicAdditions={handleDynamicAdditionsUpdate}
            dynamicDeductions={dynamicDeductions}
            setDynamicDeductions={handleDynamicDeductionsUpdate}
          />

          <div className="flex justify-end">
            <Button
              loading={loading}
              type="primary"
              size="large"
              htmlType="sumbit"
              onClick={OnSubmit}
              className="mt-5 text-end"
            >
              Generate Payslip
            </Button>
          </div>
        </Card>
      </UserPrivateComponent>
    </div>
  );
};

export default CalculatePayroll;
